/**
 * Relative paths determining site navigation method
 *
 * Path groups are prioritized and will match the first in the following order:
 * 1. Exact match Gatsby
 * 2. Exact match Next.js
 * 3. Starting match Gatsby
 * 4. Starting match Next.js
 *
 * Paths should start with a slash.
 * Starting paths very likely end with a slash.
 */
export const crossSitePaths = {
	exactGatsby: new Set([
		// Paths added here matching exactly will navigate internally
	]),
	exactNext: new Set([
		// Paths added here matching exactly will navigate cross site (through browser)
	]),
	startingGatsby: [
		// Paths added here starting with any of these values will navigate internally
	],
	startingNext: [
		// Paths added here starting with any of these values will navigate cross site (through browser)
		'/performance/',
		'/professionals/downloads/',
		'/professionals/installation-instructions/',
		'/inspiration/',
	],
};
